export default __webpack_public_path__ + "static/media/i_bus-tro_bl.724720ba.svg";